import * as React from 'react';
import Anchor from './Anchor';
import '../css/footer.sass';
import CampfireButton from './CampfireButton';
import LanguageToggle from './LanguageToggle';

export interface FooterLink {
  id: string;
  name: string;
  url: string;
}

interface FooterProps {
  links?: FooterLink[];
  footerLinksContent?: React.ReactNode;
  theme?: 'night' | 'day';
  feedback?: React.ReactNode;
  showFeedback?: boolean;
  footContent?: React.ReactNode;
  copyRight?: React.ReactNode;
  footerLogoUrl?: string;
  feedbackBtnLabel?: string;
  onLanguageChange?: Function;
  selectedLanguage?: 'en' | 'es';
  languagesOptionsCsv?: 'English,Español';
  languagesAbbreviationCsv?: 'en,es';
  showLanguageToggle?: boolean;
  feedbackBtnId?: string;
  pathToHideFeedbackBtn?: string[];
}
export default function Footer(props: FooterProps) {
  const {
    feedbackBtnLabel = 'Leave Feedback',
    feedbackBtnId = 'provideFeedbackButton',
  } = props;

  return (
    <div id="campfirefooter" className={`footer ${props.theme}`}>
      {props.showFeedback &&
        !props.pathToHideFeedbackBtn?.includes(window.location.pathname) && (
          <div className="feedback">
            <div className="t-14">{props.feedback}</div>
            <CampfireButton
              name="provideFeedbackButton"
              id={feedbackBtnId}
              label={feedbackBtnLabel}
              color={props.theme === 'night' ? 'marshmallow' : 'coal'}
              ghost
              smol
            />
          </div>
        )}
      {props.showLanguageToggle && (
        <LanguageToggle
          showToggle={props.showLanguageToggle}
          onLanguageChange={props.onLanguageChange}
          selectedLanguage={props.selectedLanguage}
          languagesOptionsCsv={props.languagesOptionsCsv}
          languagesAbbreviationCsv={props.languagesAbbreviationCsv}
          theme={props.theme}
        />
      )}
      {props.footerLinksContent || (
        <div className="links">
          {props.links?.map((link) => (
            <Anchor
              id={link.id}
              arialabel={link.name}
              href={link.url}
              key={link.id}
              type="secondary"
            >
              {link.name}
            </Anchor>
          ))}
        </div>
      )}
      {props.copyRight && <div className="copyright">{props.copyRight}</div>}
      {props.footerLogoUrl && (
        <div className="footerLogo">
          <img alt="logo" src={props.footerLogoUrl} />
        </div>
      )}
      {props.footContent && (
        <div className="footContent">{props.footContent}</div>
      )}
    </div>
  );
}
